import styles from './Loader.module.scss';
import logo from '@assets/login-logo.png';
import logo2 from '@assets/login-logo2.png';
import PropTypes from 'prop-types';
import ImageRenderer from '@components/imageRenderer/ImageRenderer'

const Loader = ({ fadeOut }) => (
  <div className={`${styles.loadingContainer} ${fadeOut ? styles.fadeOut : ''}`}>
    <div className={styles.content}>
      <ImageRenderer src={logo} alt="Logo" className={styles.logo} />
      <ImageRenderer src={logo2} alt="Logo" className={styles.logo2} />
    </div>
  </div>
);

Loader.propTypes = {
  fadeOut: PropTypes.bool.isRequired,
};

export default Loader;
